/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import { connect } from 'react-redux';
import Select, { components } from 'react-select';

var _ = require('lodash');
const selectrender = props => {
  return (
    <components.Option {...props}>
      <div>{props.data.label}</div>
      <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>
    </components.Option>
  );
};
class Imagemapcomponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locationkey: {
        value: "",
        label: ""
      }

    };

  }


  componentDidMount() {
    console.log("Comp");
    console.log(this.props.locationdata);
    window["defineapp"]({ "areas": [], "img": "https://www.unionstation.org/sites/default/files/buildingmaps/40/maps/level1.jpg", width: 1000, height: 1255 });

  }
  savemapdata = () => {
    var data = window["getdata"]();
    console.log("Timer got data");
    console.log(data);
  }
  render() {

    return (
      <div className="mainwrapper">
        <div id="imagemapwrapper">
          <header id="header1">
            <nav id="nav" className="clearfix">
              <ul>
                {/* <li id="save"><a >save</a></li> */}
                {/* <li id="load"><a >load</a></li> */}
                {/* <li id="from_html"><a >from html</a></li> */}
                <li id="rectangle"><a>Draw Rectangle</a></li>
                <li id="edit"><a >Add Location to Rectangle(Dbl click on Rectangle)</a></li>
                <li id="clear"><a >clear</a></li>
                <li id="show_help"><a >Show Help</a></li>
                <li onClick={this.savemapdata} ><a >Save</a></li>
                {/* <br></br> */}


              </ul>
            </nav>
            <div id="debug"></div>
          </header>
          <div id="coords"></div>

          <div id="image_wrapper">
            <div id="image">
              <img src="" alt="#" id="img" />
              <svg xmlns="http://www.w3.org/2000/svg" version="1.2" baseProfile="tiny" id="svg"></svg>
            </div>
          </div>
        </div>

        <div id="code">
          <span className="close_button" title="close"></span>
          <div id="code_content"></div>
        </div>

        <form id="edit_details">
          <h5>Select Location</h5>
          <input readOnly  value={this.state.locationkey.value}
            onChange={e => {
              console.log("key")
              console.log(e.target.value);
            }}

            // type="hidden" 
            id="alt_attr" />
          <input  readOnly  value={this.state.locationkey.label}
            onChange={e => {
              console.log("lable")
              console.log(e.target.value);
            }}
            // type="hidden" 
            id="title_attr" />

          <span className="close_button" title="close"></span>
          {/* <p>
            <input type="text" id="href_attr" />
          </p> */}

          <Select
            value={this.state.locationkey}
            onChange={(locationkey) => {
              this.setState({ locationkey });
            }}
            options={this.props.locationdata}
          />
          <button id="save_details">Save</button>
        </form>

        <div id="from_html_wrapper">
          <form id="from_html_form">
            <h5>Loading areas</h5>
            <span className="close_button" title="close"></span>
            <p>
              <label>Enter your html code:</label>
              <textarea id="code_input"></textarea>
            </p>
            <button id="load_code_button">Load</button>
          </form>
        </div>

        <div id="get_image_wrapper">
          <div id="get_image">
            <span title="close" className="close_button"></span>

            <div id="loading">Loading</div>
            <div id="file_reader_support">
              <label>Drag an image</label>
              <div id="dropzone">
                <span className="clear_button" title="clear">x</span>
                <img src="" alt="preview" id="sm_img" />
              </div>
              <b>or</b>
            </div>
            <label >type a url</label>
            <span id="url_wrapper">
              <span className="clear_button" title="clear">x</span>
              <input type="text" id="url" />
            </span>
            <button id="button">OK</button>
          </div>
        </div>

        <div id="overlay"></div>
        <div id="help">
          <span className="close_button" title="close"></span>
          <div className="txt">

            <section>
              <h2>Drawing mode rectangle </h2>
              <p><span className="key">ESC</span> &mdash; cancel drawing of a new area</p>
              <p><span className="key">SHIFT</span> &mdash; square drawing in case of a rectangle</p>
            </section>
            <section>
              <h2>Editing mode</h2>
              <p><span className="key">DELETE</span> &mdash; remove a selected area</p>
              <p><span className="key">ESC</span> &mdash; cancel editing of a selected area</p>
              <p><span className="key">SHIFT</span> &mdash; edit and save proportions for rectangle</p>
              <p><span className="key">I</span> &mdash; edit attributes of a selected area (or dblclick on an area)</p>
              <p><span className="key">CTRL</span> + <span className="key">C</span> &mdash; a copy of the selected area</p>
              <p><span className="key">&uarr;</span> &mdash; move a selected area up</p>
              <p><span className="key">&darr;</span> &mdash; move a selected area down</p>
              <p><span className="key">&larr;</span> &mdash; move a selected area to the left</p>
              <p><span className="key">&rarr;</span> &mdash; move a selected area to the right</p>
            </section>
          </div>

        </div>
      </div>

    )

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Imagemapcomponent);


// WEBPACK FOOTER //
// ./src/containers/Builder/Imagemapcomponent.js